// extracted by mini-css-extract-plugin
export default {"field":"styles_field__+UPYp","label":"styles_label__aAZU4"};